export function expandMatches(options, query) {
    const needle = (query || '').trim().toLowerCase();
    if (!needle) return [];

    return options.flatMap((option, optionIndex) => {
        const text = (option.raw_text || '').toLowerCase();
        const matches = [];
        let start = text.indexOf(needle);
        while (start !== -1) {
            matches.push({ option, start, length: needle.length, key: `${optionIndex}:${start}` });
            start = text.indexOf(needle, start + needle.length);
        }
        return matches.length
            ? matches
            : [{ option, start: -1, length: 0, key: `${optionIndex}:-1` }];
    });
}

export function makeSnippet(text = '', start, length) {
    // Server-side wildcard matches may have no literal occurrence to highlight.
    if (start < 0) {
        return { pre: text.slice(0, 112) + (text.length > 112 ? '…' : ''), hit: '', post: '' };
    }
    const a = Math.max(0, start - 48);
    const b = Math.min(text.length, start + length + 64);
    return {
        pre: (a > 0 ? '…' : '') + text.slice(a, start),
        hit: text.slice(start, start + length),
        post: text.slice(start + length, b) + (b < text.length ? '…' : ''),
    };
}
